<template>
    <div class="ribbon-root">
        <div class="ribbon-block">
            <div class="ribbon-select-block">
                <div class="ribbon-select">
                    <div class="ribbon-select-label">{{$t('Equipment')}}:</div>
                    <v-select
                            class="ribbon-select-select"
                            v-model="selectedEquipment"
                            :items="equipments"
                            item-value="id"
                            item-text="name"
                            v-on:change="updateEquipment"
                    />
                </div>
            </div>
        </div>
        <div class="ribbon-block separator"/>
        <div class="ribbon-block">
            <div class="ribbon-block-title">{{$t('View Settings')}}</div>
            <div class="ribbon-button-bar">
                <ribbon-button :text="$t('Display Columns')"  :image="require('@/assets/icons/toolbar/columns.svg')" @clicked="showColumnSelection"/>
                <div class="ribbon-button-two-state-box">
                    <ribbon-button-two-state :text="$t('Code Description')" :active="this.selectedCodeTexts" @clicked="toggleCodeTexts"/>
                    <ribbon-button-two-state :text="$t('Show Inactive')"    :active="this.showInactive"      @clicked="toggleShowInactive"/>
                </div>
            </div>
        </div>
        <div v-if="allowed.write" class="ribbon-block separator"/>
        <div v-if="allowed.write" class="ribbon-block">
            <div class="ribbon-block-title">{{$t('Actions')}}</div>
            <div class="ribbon-button-bar">
                <ribbon-button :text="$t('Add')"        :image="require('@/assets/icons/toolbar/add.svg')"    @clicked="$emit('addNewTag')"/>
                <ribbon-button :text="$t('Save')"       :image="require('@/assets/icons/toolbar/save.svg')"   @clicked="$emit('saveTags')"/>
                <ribbon-button :text="$t('CSV Import')" :image="require('@/assets/icons/toolbar/import.svg')" @clicked="function(){navigate('CSV Import')}"/>
            </div>
        </div>
        <selector-popup
                v-if="selectorItems"
                :items="selectorItems"
                :items-preselect="selectorItemsSelected"
                :item-text="'title'"
                :item-value="'id'"
                :filter="true"
                :filter-mode="'contains'"
                :multi-select="selectorMultiSelect"
                @itemSelected="handleSelectorSelected"
        />
    </div>

</template>

<script>
    import RibbonButton from "./RibbonButton";
    import RibbonButtonTwoState from "./RibbonButtonTwoState";
    import SelectorPopup from "../SelectorPopup";
    import authorization from "../../plugins/authorization";

    export default {
        name: "RibbonTags",
        components: {SelectorPopup, RibbonButton, RibbonButtonTwoState},
        props: {
            codeTexts:      Boolean,
            columns:        Array,

            equipment:      String,
            equipments:     Array,
        },
        data: function() {
            return {
                showInactive:        false,
                detailColumns:       ['csc', 'dppExcluded', 'iir', 'combiRepair', 'reeferMechanic', 'materialList', 'singleLine', 'flowAndTdbOnly'],
                selectedEquipment:   this.equipment,
                selectedCodeTexts:   this.codeTexts,

                selectorItems:         null,
                selectorItemsSelected: null,
                selectorMultiSelect:   null,

                allowed: {
                    read:  authorization.isAllowed('Settings/DPT Mobile/View'),
                    write: authorization.isAllowed('Settings/DPT Mobile/View', authorization.write),
                },
            };
        },
        methods: {
            async updateEquipment() {
                if (await this.$confirmLeaveDialog()) {
                    this.$emit('updateView', 'equipment', this.selectedEquipment)
                } else {
                    this.selectedEquipment = this.equipment;
                }
            },
            showColumnSelection() {
                this.selectorItems = this.columns;
                this.selectorItemsSelected = [];
                for (let columnIndex in this.columns) {
                    if (this.columns[columnIndex].visible) {
                        this.selectorItemsSelected.push(this.columns[columnIndex].id);
                    }
                }
                this.selectorMultiSelect = true;
            },
            handleSelectorSelected(selectedColumns) {
                this.selectorItems = null;
                for (let columnIndex in this.columns) {
                    this.columns[columnIndex].visible = selectedColumns.includes(this.columns[columnIndex].id);
                }
            },
            toggleShowInactive() {
                this.showInactive = !this.showInactive;
                this.$emit('updateView', 'showInactive', this.showInactive)
            },
            toggleCodeTexts() {
                this.selectedCodeTexts = !this.selectedCodeTexts;
                this.$emit('codeTexts', this.selectedCodeTexts);
            }
        },
        created: function() {
            this.$parent.$on('updateView', function(updateType, updateValue) {
                this['selected' + updateType.charAt(0).toUpperCase() + updateType.slice(1)] = updateValue;
            });
        }
    }
</script>

<style scoped>
    div.ribbon-root {
        text-align: left;
        height: 104px;
        background-color: var(--toolbar-background);
    }
    div.ribbon-root > div {
        display: inline-block;
    }
    div.ribbon-block {
        margin-left: 8px;
        margin-right: 8px;
        height: 104px;
        vertical-align: top;
    }
    div.ribbon-block.separator {
        background-color: var(--toolbar-separator);
        width: 1px;
        margin: 8px 0;
        height: 88px;
    }
    div.ribbon-block-title {
        font-size: 12px;
        color: var(--toolbar-label);
        text-align: center;
        padding-top: 8px;
    }
    div.ribbon-select-block {
        display: inline-block;
        padding-top: 8px;
    }
    div.ribbon-select-block:not(:last-child) {
        margin-right: 8px
    }
    div.ribbon-select {
        height: 30px;
        overflow: hidden;
    }
    div.ribbon-select > div {display: inline-block}
    div.ribbon-select-label {
        color: var(--toolbar-label);
        display: inline-block;
        width: 120px;
        font-size: 14px;
        height: 30px;
        vertical-align: top;
        line-height: 220%;
    }
    div.ribbon-button-two-state-box {
        display: inline-block;
        width: 136px;
        height: 72px;
        padding: 8px 0;
    }

</style>